import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD_CAPITALSTATE}`

const fetchBalance = (query) => http.get(`${api}/gerencia/cuenta-perdidas-ganancias`, { params: { ...query } })

export {
  fetchBalance
}
